// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2H18V6H23V22H13V15H11V22H1V8H6V2ZM21 8H18V20H21V8ZM3 20H6V10H3V20Z"}}]};

const City6FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-6-filled',
    ref,
    icon: element,
  },
));

City6FilledIcon.displayName = 'City6FilledIcon';

export default City6FilledIcon;
